<template>
  <span v-if="isProgress">
    <div class="form-line">
      <div class="progress-indicator">{{ number }}%</div>
      <input
        :id="htmlId"
        type="range"
        :name="id"
        :min="numeric.min"
        :max="numeric.max"
        :step="numeric.step"
        :value="number"
        class="asd-input"
        @input="handleNumericInput"
      />
    </div>
  </span>
  <span v-else>
    <div class="form-line">
      <input
        :id="htmlId"
        v-validate.initial
        :value="number"
        type="number"
        class="asd-input has-units"
        :name="id"
        :autocomplete="htmlId"
        :min="numeric.min"
        :max="numeric.max"
        :disabled="visibility > 0"
        :step="step"
        @input="handleNumericInput"
        @focus="autocompleteOpened = true"
      />
      <select v-if="numeric.unitsOptions && numeric.unitsOptions.length" class="asd-input units"
              :value="unit"
              @input="handleUnitsInput"
      >
        <option v-for="unit in numeric.unitsOptions" :key="unit.shortcut" :value="unit.shortcut">
          {{ unit.shortcut }} [{{ unit.name }}]
        </option>
      </select>
    </div>
    <ul class="input-errors">
      <li v-for="e in errors.collect(id)" :key="e">{{ e }}</li>
    </ul>
  </span>
</template>

<script>
import DataTypeProsMixin from 'CORE/mixins/dataType'
import _ from 'lodash'

export default {
    name: 'NumericInput',
    mixins: [
        DataTypeProsMixin,
    ],
    data() {
        return {
            number: undefined,
            unit: undefined,
        }
    },
    computed: {
        numeric() {
            return _.get(this.propertyType, 'settings.numeric', {})
        },
        step() {
            const step = _.get(this.numeric, 'step', '')
            if (_.size(step) === 0) {
                return 'any'
            } else {
                return step
            }
        },
        isProgress() {
            return _.get(this.propertyType, 'settings.systags.progress', false)
        },
    },
    mounted() {
        this.unit = _.get(this, 'value.value.value.unit', undefined)
        if (this.unit === undefined) this.unit = _.get(this, 'numeric.unitsOptions[0].shortcut', undefined)
        this.number = _.get(this.value, 'value.value.number', 0)
    },
    methods: {
        handleNumericInput(e) {
            const input = e.target.value
            if (_.size(input) > 0) {
                this.number = _.toNumber(e.target.value)
            } else {
                this.number = undefined
            }
            this.input()
        },
        handleUnitsInput(e) {
            this.unit = e.target.value
            this.input()
        },
        input() {
            this.$emit('input', { value: { value: { number: this.number, unit: this.unit } } })
        },
    },
}
</script>

<style scoped lang="scss">
.units {
    border-left: 0;
    background: white;
    -webkit-appearance: none;
    -moz-appearance: none;
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    padding: 0 6px 0 0;
    widows: 40%;
}
input.has-units {
    border-right: 0;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
}

ul.input-errors {
    margin: 5px auto 0 30px;
}
ul.input-errors > li {
    color: var(--danger);
    font-style: italic;
    list-style: square;
}
.form-line {
    display: flex;
    &>* {
        flex-grow: 1;
        width: auto;
    }
}
.progress-indicator {
    flex-basis: 30px;
    display: block;
    flex-grow: 0;
    line-height: 2.5rem;
    color: var(--blue);
}
</style>
